import React from 'react';
import { ClipboardListIcon, CompassIcon, MapIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
const items = [{
  Icon: CompassIcon,
  title: 'The Master Decision Map™',
  body: 'Start from the clinical situation and navigate to the appropriate pathway.'
}, {
  Icon: ZapIcon,
  title: 'The 5-Minute Decision Routes™',
  body: 'Structured pathways designed around the most common renal decision scenarios.'
}, {
  Icon: ClipboardListIcon,
  title: 'Smart Clinical Checklists™',
  body: 'A repeatable framework for assessment, decision-making, monitoring, follow-up and referral considerations.'
}, {
  Icon: SmartphoneIcon,
  title: 'Point-of-Care Reference Pages™',
  body: 'Designed for digital use on desktop, tablet and phone — plus printable versions.'
}, {
  Icon: MapIcon,
  title: 'Clinical Navigation System™',
  body: 'Instead of searching through hundreds of pages, start with the scenario and follow the route.'
}];
export function InstantDelivery() {
  return <Section eyebrow="Instant delivery" title="What will you receive immediately after your purchase?" subtitle="From the first minute, you’ll have a complete renal decision-navigation system ready to use as a reference during your next consultation." data-id="element-205" data-mp="3lwm9m4lxefzt">
      <ul className="grid gap-3.5 sm:grid-cols-2 sm:gap-4" data-id="element-206" data-mp="2y9e7twnphp2j">
        {items.map(({
        Icon,
        title,
        body
      }, index) => <li key={title} className={`flex gap-3.5 rounded-2xl border border-ink-line bg-white p-5 ${index === items.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-207" data-mp="338hchfzrxt9z" data-mpi={index}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cyan-light" data-id="element-208" data-mp="3c1auhl6lv6rj">
              <Icon className="h-5 w-5 text-cyan-brand" aria-hidden="true" data-id="element-209" data-mp="2fg0sgzwh7r81" />
            </span>
            <div data-id="element-210" data-mp="2jhm1ga5w3lcy">
              <h3 className="font-display text-[17px] font-bold leading-snug text-ink" data-id="element-211" data-mp="3mume1pib32sq">
                {title}
              </h3>
              <p className="mt-1.5 text-[14px] leading-relaxed text-ink-soft" data-id="element-212" data-mp="3hwb1v84jgg7c">
                {body}
              </p>
            </div>
          </li>)}
      </ul>

      <TransformCTA label="I want instant access today" sub="Delivered in minutes • Desktop, tablet, phone and printable" data-id="element-213" data-mp="3rlcld8aalfq2" />
    </Section>;
}